export default function validateImportMapping(way, mapping, additionalMapping) {
    this.dsClear();
    this.unmarkDuplicates(way, mapping, additionalMapping);
    const haveDuplicates = this.findDuplicates(way, mapping, additionalMapping);
    this.dsProcess();

    return !haveDuplicates;
}